import TextExtractionModelInput from "./input/TextExtraction/TextExtractionModelInput";
import TranslationModelInput from "./input/Translation/TranslationModelInput";
import TranslationModelOutput from "./output/Translation/TranslationModelOutput";
import VideoToTextModelInput from "./input/VideoToText/VideoToTextModelInput";
import SpeechRecognitionModelInput from "./input/SpeechRecognition/SpeechRecognitionModelInput";
import TextEmotionModelOutput from "./output/TextEmotion/TextEmotionModelOutput";
import NERModelOutput from "./output/NamedEntityRecognition/NERModelOutput";
import QuestionAnsweringModelOutput from "./output/QuestionAnswering/QuestionAnsweringModelOutput";
import QuestionAnsweringModelInput from "./input/QuestionAnswering/QuestionAnsweringModelInput";
import ArticleKeywordsModelOutput from "./output/ArticleKeywords/ArticleKeywordsModelOutput";
import TextSentimentModelOutput from "./output/TextSentiment/TextSentimentModelOutput";
import TextSentimentModelInput from "./input/TextSentiment/TextSentimentModelInput";
import TextToSpeechModelInput from "./input/TextToSpeech/TextToSpeechModelInput";
import TextToSpeechModelOutput from "./output/TextToSpeech/TextToSpeechModelOutput";

const Config: any = {
    text_extraction: {
        modelId: "text_extraction",
        modelName: "Text Extraction",
        inputForm: TextExtractionModelInput,
        inputArguments: [{
            source: "previous_model_output",
            type: "file",
            name: "file"
        }],
        output: {
            name: "text"
        },
        combinableModels: ["text_sentiment", "ner_extraction", "article_keywords",
            "translationSecondLayer", "text_to_speech", "question_answering", "text_emotion"]
    },
    translation: {
        modelId: "translation",
        modelName: "Translation",
        inputForm: TranslationModelInput,
        outputForm: TranslationModelOutput,
        hasMandatoryUserInputs: true,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "text"
        }, {
            source: "request",
            type: "text",
            name: "source_lang"
        }, {
            source: "request",
            type: "text",
            name: "destination_lang"
        }],
        output: {
            name: "result"
        },
        combinableModels: ["text_sentiment", "ner_extraction", "article_keywords",
            "text_to_speech", "question_answering", "text_emotion"]
    },
    translationSecondLayer: {
        modelId: "translation",
        modelName: "Translation",
        inputForm: TranslationModelInput,
        outputForm: TranslationModelOutput,
        hasMandatoryUserInputs: true,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "text"
        }, {
            source: "request",
            type: "text",
            name: "source_lang"
        }, {
            source: "request",
            type: "text",
            name: "destination_lang"
        }],
        output: {
            name: "result"
        },
        combinableModels: ["text_to_speech"]
    },
    video_to_text: {
        modelId: "video_to_text",
        modelName: "Video To Text",
        inputForm: VideoToTextModelInput,
        hasMandatoryUserInputs: true,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "url"
        }, {
            source: "request",
            type: "text",
            name: "language_code"
        }],
        output: {
            name: "transcript"
        },
        combinableModels: ["text_sentiment", "ner_extraction", "article_keywords",
            "translationSecondLayer", "text_to_speech", "question_answering", "text_emotion"]
    },
    speech_recognition: {
        modelId: "speech_recognition",
        modelName: "Speech Recognition",
        inputForm: SpeechRecognitionModelInput,
        inputArguments: [{
            source: "previous_model_output",
            type: "file",
            name: "audio_data"
        }, {
            source: "request",
            type: "text",
            name: "language_code"
        }, {
            source: "request",
            type: "text",
            name: "media_format"
        }],
        output: {
            name: "transcript"
        },
        combinableModels: ["text_sentiment", "ner_extraction", "article_keywords",
            "translationSecondLayer", "text_to_speech", "question_answering", "text_emotion"]
    },
    text_sentiment: {
        modelId: "text_sentiment",
        modelName: "Text Sentiment",
        inputForm: TextSentimentModelInput,
        outputForm: TextSentimentModelOutput,
        hasMandatoryUserInputs: true,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "Text"
        }, {
            source: "request",
            type: "text",
            name: "LanguageCode"
        }]
    },
    ner_extraction: {
        modelId: "named_entity_recognition",
        modelName: "NER Model",
        outputForm: NERModelOutput,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "text"
        }],
        usesModelInput: true
    },
    article_keywords: {
        modelId: "article_keywords",
        modelName: "Article Keywords",
        outputForm: ArticleKeywordsModelOutput,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "text"
        }]
    },
    text_to_speech: {
        modelId: "text_to_speech",
        modelName: "Text To Speech",
        inputForm: TextToSpeechModelInput,
        outputForm: TextToSpeechModelOutput,
        hasMandatoryUserInputs: true,
        hasMetaData: true,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "text"
        }, {
            source: "request",
            type: "text",
            name: "language_code"
        }, {
            source: "request",
            type: "text",
            name: "gender"
        }, {
            source: "request",
            type: "text",
            name: "name"
        }, {
            source: "request",
            type: "text",
            name: "speaking_rate"
        }, {
            source: "request",
            type: "text",
            name: "pitch"
        }],
        outputsFile: true,
        outputFileMimeType: "audio/mpeg",
        outputFieldName: "audio"
    },
    question_answering: {
        modelId: "question_answering",
        modelName: "Q/A Model",
        inputForm: QuestionAnsweringModelInput,
        outputForm: QuestionAnsweringModelOutput,
        hasMandatoryUserInputs: true,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "context"
        }, {
            source: "request",
            type: "text",
            name: "question"
        }]
    },
    text_emotion: {
        modelId: "text_emotion",
        modelName: "Text Emotion",
        outputForm: TextEmotionModelOutput,
        inputArguments: [{
            source: "previous_model_output",
            type: "text",
            name: "text"
        }]
    },
};

export default Config;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/Config.tsx